import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { IssueRecord } from '@/entities/issue/v2';
import { Modal } from '@/ui/components/Modal';
import { pageSubtitle } from '@/ui/components';
import { VNodeData } from 'vue/types/vnode.d';
import { Button } from '@/ui/components/Button';

export interface IssueListProps {
  subtitle?: string;
  issues: IssueRecord[];
}

export const IssuesListModal = defineComponent<IssueListProps>({
  name: 'IssuesListModal',
  props: ['issues', 'subtitle'],
  setup(props, context) {
    const onIssueSelection = (issue: IssueRecord) => {
      context.emit('selected:issue', issue);
    };

    const closeModal = () => {
      context.emit('close');
    };

    const onCreateIssueClick = () => {
      context.emit('create:issue:click');
    };

    return function render() {
      return h(Modal, {
        props: {
          active: true,
          ariaRole: 'dialog',
          trapFocus: true,
          destroyOnHide: false,
          ariaModal: true,
          width: '625px',
          canCancel: ['x'],
        },
        scopedSlots: {
          actions: () => h('div', [
            h(Button, {
              on: { click: closeModal },
            }, t('common.close')),
          ]),
        },
        on: {
          close: closeModal,
        },
      }, [
        pageSubtitle(t('inspections.raise-issue')),
        h('div', [
          h('div', {
            class: 'mb-4',
          },
          [
            props.subtitle
              ? props.subtitle
              : t('inspections.issue-raised', { numberIssuesRaised: props.issues.length.toString() })]),
          props
            .issues
            .map(issue => h('div', { class: 'negative-answers__issue-list-row' }, [
              h('div', { class: 'negative-answers__issue-list-row-index' }, issue.data.title),
              issue.authorizedTo.update
                ? h('a', {
                  class: 'negative-answers__issue-list-row-link',
                  on: { click: () => onIssueSelection(issue) },
                }, t('issues.edit-view'))
                : null,
            ])),
          h('a', {
            class: 'has-text-weight-semibold',
            on: { click: onCreateIssueClick },
          }, t('issues.create-another-action')),
        ]),
      ]);
    };
  },
});

export function issuesList(data: VNodeData & { props: IssueListProps }) {
  return h(IssuesListModal, data);
}
